import { render, staticRenderFns } from "./RegisterXeroFallback.vue?vue&type=template&id=435f573c&"
import script from "./RegisterXeroFallback.vue?vue&type=script&lang=js&"
export * from "./RegisterXeroFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports